import styled from 'styled-components'

import AddConversionReportFormUnstyled from 'Containers/Form/Campaigns/AddConversionReport/unstyled'

export const StyledWrapper = styled.div`
  padding: 0px 30px 70px;
`

export const StyledWarningWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  color: #ee4360;
`

export const StyledDropzoneWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  min-height: 50px;
`

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`

export const AddConversionReportForm = styled(AddConversionReportFormUnstyled)`
  margin: 0 -15px;

  .row {
    margin: 0 0 30px 0;
  }

  .row:last-child {
    margin: 0;
  }

  .upload-report {
    cursor: pointer;
  }
`
